/**
 * Ryan O'Dowd
 * 2024-02-26
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors, windowWidth}) => {
  return {
    chapterHistoryRow: {
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: globalScale * 4,
      minWidth: Math.min(400, windowWidth - 100), // @TODO: don't like this 100
    },
    chapterHistoryListItem: {
      flex: 1,
    },
    chapterHistoryText: {
      fontSize: globalScale * 16,
      color: colors.white,
      fontFamily: fonts.secondaryBold,
    },
    removeButton: {
    },
  };
};

export default getStyles;
